import { ContentShellViewStyle } from '@levelapp/softfabric';

export default class ShellUsersViewStyle extends ContentShellViewStyle{}